module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    ref: "img"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca0fa4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/authImg/index.vue
// module id = 1770
// module chunks = 1